import React from "react";

export const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero-Header – optisch konsistent mit deinen Unterseiten */}
      <section className="relative py-24 md:py-32 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 -left-20 w-96 h-96 bg-gradient-to-r from-purple-600/30 to-orange-500/30 rounded-full blur-3xl animate-float" />
          <div
            className="absolute bottom-1/4 -right-20 w-80 h-80 bg-gradient-to-r from-orange-500/30 to-purple-600/30 rounded-full blur-3xl animate-float"
            style={{ animationDelay: "-3s" }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mb-6">
              <span className="gradient-text font-medium">Impressum</span>
              <br />
              Rechtliche Angaben & Verantwortlichkeiten
            </h1>
            <p className="text-sm md:text-base text-slate-200 max-w-3xl mx-auto leading-relaxed font-light">
              Dieses Impressum gilt für die Website{" "}
              <span className="font-medium">www.globalegroupe.com</span>{" "}
              sowie alle dazugehörigen Unterseiten und Online-Angebote von{" "}
              <span className="font-medium">Globale Groupe</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Inhalt */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 space-y-12 text-sm md:text-base text-slate-700 leading-relaxed">
          {/* Anbieterkennzeichnung */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Angaben gemäß §&nbsp;5 TMG / §&nbsp;18 MStV
            </h2>
            <p>
              Globale Groupe
              <br />
              Independent Consultancy
              <br />
              (Rechtsform in Abstimmung)
            </p>
            <p className="mt-2">
              Vertreten durch: <span className="font-medium">Rachid El Mokhi</span>
            </p>
            <p className="mt-2">
              in Abstimmung
              <br />
              Baden-Baden
              <br />
              Deutschland
            </p>

            <p className="mt-4">
              Telefon: geschäftliche Telefonnummer
              <br />
              E-Mail:{" "}
              <span className="break-all">
                contact@globalegroupe.com
              </span>
              <br />
              Website: www.globalegroupe.de
            </p>

            <p className="mt-4">
              Verantwortlich für den Inhalt nach §&nbsp;18 Abs.&nbsp;2 MStV:
              <br />
              <span className="font-medium">Rachid El Mokhi</span>, Anschrift wie oben
            </p>
          </section>

          {/* Register & USt */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Registereintrag & Umsatzsteuer
            </h2>
            <p>
              wird finalisiert
              <br />
              Registernummer: Handelsregister- / Partnerschaftsregister- /
              Vereinsregisternummer, falls vorhanden
            </p>
            <p className="mt-2">
              Umsatzsteuer-Identifikationsnummer gemäß §&nbsp;27a UStG: USt-IdNr.,
              wird finalisiert
            </p>
            <p className="mt-2">
              
            </p>
          </section>

          {/* Berufsrecht (falls relevant) */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Berufsrechtliche Angaben
            </h2>
            <p>
              Die Tätigkeit von Globale Groupe umfasst insbesondere
              Unternehmensberatung, Organisationsentwicklung, Executive Coaching,
              Leadership- und Kultur-Programme sowie Trainings- und Workshopformate
              für Organisationen.
            </p>
            <p className="mt-2">
              Es handelt sich nicht um Rechtsberatung, Steuerberatung,
              psychotherapeutische oder medizinische Dienstleistungen.
            </p>
            <p className="mt-2">
              Sofern für einzelne Tätigkeiten besondere Berufs- oder
              Kammerzugehörigkeiten bestehen (z.&nbsp;B. Rechtsanwälte,
              Steuerberater, Ärzte), sind diese hier zu ergänzen:
            </p>
            <p className="mt-2">
              Berufsbezeichnung: offizielle Berufsbezeichnung, falls regulierter Beruf
              <br />
              Verliehen in: Staat, in dem die Berufsbezeichnung verliehen wurde
              <br />
              Zuständige Kammer / Aufsichtsbehörde: Name und Anschrift der Kammer /
              Aufsichtsbehörde, falls relevant
            </p>
          </section>

          {/* Geltungsbereich B2B */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Geltungsbereich des Angebots / Zielgruppe
            </h2>
            <p>
              Die auf dieser Website beschriebenen Leistungen (Beratung, Coaching,
              Trainings, Programme, insbesondere TRIAX®-basierte Formate, CultureBridge
              MENA, Scrum4Sales, Change Sparring und Leadership Resonanz Atelier)
              richten sich ausschließlich an Unternehmer im Sinne des §&nbsp;14 BGB,
              also Unternehmen, Organisationen, Körperschaften des öffentlichen
              Rechts sowie deren Organe und Führungskräfte.
            </p>
            <p className="mt-2">
              Verbraucher im Sinne des §&nbsp;13 BGB werden von diesem Angebot nicht
              adressiert.
            </p>
          </section>

          {/* Haftung Inhalte */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß §&nbsp;7 Abs.&nbsp;1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              Nach §§&nbsp;8 bis&nbsp;10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
              überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen.
            </p>
            <p className="mt-2">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
              entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren
              Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
              Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
              verantwortlich.
            </p>
            <p className="mt-2">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
              ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
              Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
              entfernen.
            </p>
          </section>

          {/* Beratungs-/Coaching-Disclaimer */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Beratung, Coaching & Verantwortungsbereich
            </h2>
            <p>
              Die auf dieser Website beschriebenen Beratungs-, Coaching- und
              Trainingsleistungen unterstützen Entscheidungsträgerinnen und
              Entscheidungsträger in Organisationen bei der Reflexion, Planung und
              Umsetzung von Veränderungsprozessen. Sie ersetzen jedoch keine
              eigenverantwortliche Entscheidung und keine individuelle Rechts-, Steuer-,
              Finanz-, Medizin- oder Therapieberatung.
            </p>
            <p className="mt-2">
              Entscheidungen über Strategien, Investitionen, Personalmaßnahmen und
              sonstige unternehmerische Schritte werden ausschließlich von unseren
              Auftraggebern getroffen und verantwortet. Für konkrete Entscheidungen
              und deren Folgen übernimmt Globale Groupe keine Haftung; dies gilt
              insbesondere für wirtschaftliche Ergebnisse, Markt- oder
              Kursentwicklungen, Verhandlungs-Outcome oder interne
              Personalentscheidungen, soweit nicht zwingende gesetzliche Vorschriften
              entgegenstehen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Urheberrecht / geistiges Eigentum
            </h2>
            <p>
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen
              Seiten unterliegen dem deutschen Urheberrecht. Vervielfältigung,
              Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der vorherigen schriftlichen
              Zustimmung von Globale Groupe bzw. der jeweils Berechtigten.
            </p>
            <p className="mt-2">
              Dies gilt insbesondere für das TRIAX®-Modell, sämtliche beschriebenen
              Programme (u.&nbsp;a. CultureBridge MENA, Scrum4Sales, Scrum4Sales
              Sprint, Change Sparring 6, Leadership Resonanz Atelier) sowie alle
              Texte, Konzepte, Grafiken, Layouts und Präsentationslogiken dieser
              Website.
            </p>
            <p className="mt-2">
              Soweit Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
              werden die Urheberrechte Dritter beachtet und entsprechend
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
              aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
              umgehend entfernen.
            </p>
          </section>

          {/* Bildnachweise / Medien */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Bildnachweise & Medienquellen
            </h2>
            <p>
              Auf dieser Website werden neben eigenen Foto- und Grafikmaterialien auch
              Bilder externer Quellen verwendet (z.&nbsp;B. lizenzierte Stock-Fotos,
              insbesondere von Unsplash).
            </p>
            <p className="mt-2">
              Quellenangaben (soweit erforderlich oder vertraglich vorgesehen): Liste
              der Bildquellen / Fotograf:innen / Plattformen, z.&nbsp;B.
              Unsplash-Profile
            </p>
          </section>

          {/* Hosting / technische Dienste */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Hosting & technische Dienstleister
            </h2>
            <p>
              Diese Website wird bei folgendem Dienstleister betrieben
              (Hosting-Provider):
            </p>
            <p className="mt-2">
              Hoster, z.&nbsp;B. Hostinger International Ltd., inkl. Anschrift falls
              gewünscht
            </p>
            <p className="mt-2">
              Für den Versand von Kontaktformular-Nachrichten und E-Mails können
              externe Dienstleister (z.&nbsp;B. EmailJS, LinkedIn, andere
              Kommunikations- und CRM-Systeme) eingesetzt werden. Details zur
              Verarbeitung personenbezogener Daten finden Sie in unserer{" "}
              <a
                href="/datenschutz"
                className="text-purple-600 hover:text-purple-800 underline"
              >
                Datenschutzerklärung
              </a>
              .
            </p>
          </section>

          {/* Online-Streitbeilegung / Verbraucherschlichtung */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Online-Streitbeilegung & Verbraucherschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noreferrer"
                className="text-purple-600 hover:text-purple-800 underline"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="mt-2">
              Wir sind weder bereit noch verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen, da unser Angebot auf Geschäftskunden ausgerichtet ist.
            </p>
          </section>

          {/* Sprachregelung */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Sprachversionen
            </h2>
            <p>
              Soweit Teile dieser Website oder dieses Impressums in andere Sprachen
              (z.&nbsp;B. Englisch, Französisch, Arabisch) übersetzt werden, dienen
              diese Übersetzungen ausschließlich der besseren Verständlichkeit für
              internationale Nutzerinnen und Nutzer.
            </p>
            <p className="mt-2">
              Rechtlich maßgeblich ist ausschließlich die{" "}
              <span className="font-medium">deutsche</span> Sprachfassung dieses
              Impressums und der übrigen Rechtstexte (z.&nbsp;B.
              Datenschutzerklärung, Allgemeine Geschäftsbedingungen).
            </p>
          </section>

          {/* Schlussklausel */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">
              Stand & Aktualisierung
            </h2>
            <p>Stand dieses Impressums: Dezember 2025</p>
            <p className="mt-2">
              Wir behalten uns vor, dieses Impressum sowie alle rechtlichen Hinweise
              bei Bedarf anzupassen, insbesondere bei Änderungen der Rechtslage,
              unserer Leistungen oder der technischen Umsetzung dieser Website.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
};
